import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Tooltip from "@material-ui/core/Tooltip";
import { IconButton } from "@material-ui/core";
import { Link } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import Icon from "@material-ui/core/Icon";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Description from "@material-ui/icons/Description";
import Menu from "@material-ui/core/Menu";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import AttachEmailIcon from "@material-ui/icons/Email";
import FormUpload from "../../common/FormUpload";
import EmailForm from "../EmailForm";
import { createSelector } from "../../common/orm";


import Box from "@material-ui/core/Box";
import { Form } from "react-form";
import ReactSelectAsync from "../../common/ReactSelectAsync";
import HelpLabel from "../../common/HelpLabel";


const styles = (theme) => ({
    iconbutton: {
        float: "right",
        fontSize: 32,
        marginRight: 27,
    },
    hideSmall: {
        [theme.breakpoints.down("md")]: {
            display: "none",
        },
    },
    hideLarge: {
        [theme.breakpoints.up("lg")]: {
            display: "none",
        },
    },
    flex: {
        flex: 1,
    },
    listItem: {
        borderBottom: "1px solid #262626",
    },
    topListItem: {
        borderBottom: "1px solid #262626",
        backgroundColor: "#eee",
        cursor: "default",
        textAlign: "center",
    },
    list: {
        "& ul": {
            padding: 0,
        },
    },
    topButtons: {
        position: "fixed",
        zIndex: 2,
        backgroundColor: "#f0f0f0",
        paddingBottom: 10,
        marginTop: -13,
        marginLeft: -3,
        [theme.breakpoints.down(601)]: {
            marginTop: -36,
        },
    },
    label: {
        marginTop: 18,
        display: "inline-block",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        [theme.breakpoints.down("md")]: {
            maxWidth: "calc(100% - 75px)",
        },
        [theme.breakpoints.up("lg")]: {
            maxWidth: "calc(100% - 450px)",
        },
    },
});

const getPermission = createSelector(
    (state, ownProps) => parseInt(ownProps.match.params["pageId"]),
    (session, pageId) => session.Permission.filter((p) => p.page === pageId).toRefArray()
);

//only used for label on header
const getRecordSection = createSelector(
    (state, ownProps) => parseInt(ownProps.match.params["parentRecordId"]),
    (session, pr) => {
        return session.RecordSection.filter((rs) => rs.parentrecord === pr).toRefArray();
    }
);

class TopButtons extends Component {
    state = {
        open: false,
        helpMenu: null,
        smallAnchor: null,
        smallAnchor2: null,
        emailFormOpen: false,
        emailUrl: null,
        emailReportName: null,
        activeReport: null,

        smallAnchor3: null,
    };

    handleHelpMenu = (event) => {
        this.setState({ helpMenu: event.currentTarget });
    };

    handleHelpMenuClose = () => {
        this.setState({ helpMenu: null });
    };
    handleSmallMenu = (event) => {
        this.setState({ smallAnchor: event.currentTarget });
    };

    handleSmallMenuClose = () => {
        this.setState({ smallAnchor: null });
    };

    handleSmallMenu2 = (event, t) => {
        this.setState({ smallAnchor2: event.currentTarget, activeReport: t });
    };

    handleSmallMenuClose2 = () => {
        this.setState({ smallAnchor2: null });
    };

    returnDialog = () => {
        this.setState({ emailFormOpen: false });
    };


    handleSmallMenu3 = (event, t) => {
        this.setState({ smallAnchor3: event.currentTarget });
    };

    handleSmallMenuClose3 = () => {
        this.setState({ smallAnchor3: null });
    };



    render() {
        const { classes, section, page, authState, readOnly, perm, recordsection, templates, showPageName, navState, fromAnalytics, rs,
            permission,
        } = this.props;
        const { open, helpMenu, smallAnchor, smallAnchor2, emailFormOpen, emailUrl, emailReportName, activeReport,
            smallAnchor3,
            openFieldSettings
        } = this.state;

        const userHelpOpen = Boolean(helpMenu);
        const smallMenuOpen = Boolean(smallAnchor);
        const smallMenuOpen2 = Boolean(smallAnchor2);

        const smallMenuOpen3 = Boolean(smallAnchor3);


        var dashboard = window.location.href.includes("/dashboard/");

        //needed for collapsed menu bar with open viewable window
        let thisWidth;
        if (window.innerWidth < 601) thisWidth = "calc(100% - 50px)";
        else if (window.innerWidth < 960) thisWidth = "calc(100% - 74px)";
        else if (window.innerWidth < 1280 && window.innerWidth > 960 && !navState.pagesOpen) thisWidth = "calc(100% - 92px)";
        else if (window.innerWidth < 1280 && window.innerWidth > 960 && navState.pagesOpen) thisWidth = "calc(100% - 289px)";
        else if (window.innerWidth > 1280 && navState.pagesOpen) thisWidth = "calc(100% - 335px)";
        else thisWidth = "calc(100% - 80px)"; //pages closed but larger screen        

        //permissions
        if (authState?.user) {
            let readOnly;
            const perm = (permission || []).find((p) => {
                if (p.user === authState.user.id) {
                    return p;
                }
                return null;
            });
            if (perm) readOnly = perm.readonly || perm.readonlyexternal ? true : false;
            if (readOnly === undefined) readOnly = false;
        }

        return (
            <>
                {page && (
                    <Grid
                        container
                        spacing={0}
                        className={!fromAnalytics ? classes.topButtons : null}
                        style={{ width: !fromAnalytics ? thisWidth : null }}
                    >

                        {/* if the url location has form or table. The form needs padding*/}
                        {(this.props.match.path.includes("form")) && (
                            <Box
                                sx={{
                                    width: '100%',
                                    height: '16px',
                                    marginTop: '12px',
                                    marginBottom: '10px',
                                    flex: '1 1 50%',
                                    display: 'flex',
                                    justifyContent: 'flex-start',
                                    minWidth: '50%'
                                }}
                            >

                                <Form
                                    validateOnSubmit={false}
                                    style={{
                                        zIndex: 1000,
                                        position: 'relative',
                                        width: '90%'
                                    }}
                                >
                                    {() => (
                                        <form
                                            style={{ width: '100%' }}
                                        >
                                            <Box
                                                sx={{ width: '100%' }}
                                            >

                                                <ReactSelectAsync
                                                    field={22}
                                                    page={this.props.page.id}
                                                    quick_search_field="All Columns"
                                                    placeholder="Search for Primary Records within this Module"
                                                    menuPortalTarget={document.body}
                                                    eventHandle={(searchvalue) => {
                                                        if (searchvalue !== "") {
                                                            this.props.history.push(
                                                                "/page/" +
                                                                searchvalue.pageid +
                                                                "/parentrecord/" +
                                                                searchvalue.parentrecord +
                                                                "/section/" +
                                                                searchvalue.section +
                                                                "/recordsection/" +
                                                                searchvalue.recordsection +
                                                                "/form"
                                                            );
                                                        }
                                                    }}
                                                />
                                            </Box>
                                        </form>
                                    )}
                                </Form>

                                <Box
                                    sx={{
                                        marginTop: '20px',
                                        marginLeft: '8px',
                                        flex: '0 0 15%',
                                    }}
                                >
                                    <HelpLabel
                                        helpText={`
                                        The search tool only searches primary table column form fields.
                                        `}
                                    />
                                </Box>

                                <Box
                                    sx={{
                                        flex: '0 0 50%',
                                        display: 'flex',
                                        justifyContent: 'flex-end'
                                    }}
                                >
                                    <div style={{ whiteSpace: "nowrap", float: "right", marginTop: 4 }}>
                                        {authState.user && authState.user.is_city_admin === true && (
                                            <Tooltip className={classes.hideSmall} title="Module Configuration">
                                                <IconButton
                                                    disabled={readOnly}
                                                    className={classes.iconbutton}
                                                    component={Link}
                                                    to={"/page/" + page.id + "/config"} //route to page config
                                                >
                                                    <Icon>settings</Icon>
                                                </IconButton>
                                            </Tooltip>
                                        )}
                                        {section && (
                                            <Tooltip className={classes.hideSmall} title={"Search"}>
                                                <IconButton
                                                    className={classes.iconbutton}
                                                    component={Link}
                                                    to={"/page/" + page.id + "/advancedsearch"}>
                                                    <Icon>search</Icon>
                                                </IconButton>
                                            </Tooltip>
                                        )}
                                        {section && section.has_geometry && (
                                            <Tooltip className={classes.hideSmall} title={`${page.name} Map`}>
                                                <IconButton
                                                    className={classes.iconbutton}
                                                    component={Link}
                                                    to={"/map/" + page.id + "/section/" + 0 + "/advancedsearch/" + 1}>
                                                    <Icon>map</Icon>
                                                </IconButton>
                                            </Tooltip>
                                        )}
                                        {section && !section.is_master_contact_form && !section.is_time_series_chart && (
                                            <Tooltip className={classes.hideSmall} title={"Table View"}>
                                                <IconButton
                                                    className={classes.iconbutton}
                                                    component={Link}
                                                    to={"/page/" + page.id + "/" + section.id + "/table"} //route to section table view of all records for that page
                                                >
                                                    <Icon>view_headline </Icon>
                                                </IconButton>
                                            </Tooltip>
                                        )}
                                        {page && !dashboard && (
                                            <Tooltip className={classes.hideSmall} title={`Dashboard`}>
                                                <IconButton className={classes.iconbutton} component={Link} to={"/dashboard/" + page.id}>
                                                    <Icon>timeline</Icon>
                                                </IconButton>
                                            </Tooltip>
                                        )}
                                        {recordsection && perm && !perm.readonlyexternal && (
                                            <Tooltip className={classes.hideSmall} title="Reports" placement="bottom-start" enterDelay={300}>
                                                <IconButton className={classes.iconbutton} onClick={this.handleHelpMenu}>
                                                    <Description />
                                                </IconButton>
                                            </Tooltip>
                                        )}
                                        <Tooltip className={classes.hideLarge} title="Module Menu" placement="bottom-start" enterDelay={300}>
                                            <IconButton className={classes.iconbutton} onClick={this.handleSmallMenu}>
                                                <MoreVertIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </div>
                                </Box>
                            </Box>
                        )}

                        <Grid item xs={12}>
                            {showPageName && rs.length > 0 && (
                                <Tooltip className={classes.hideSmall} title={page.name + (rs && rs[0].parentinfo && " - " + rs[0].parentinfo.label)}>
                                    <Typography variant="h5" className={classes.label}>
                                        {page.name} {rs && rs[0].parentinfo && " - " + rs[0].parentinfo.label}
                                    </Typography>
                                </Tooltip>
                            )}

                            {(this.props.match.path.includes("dashboard")) && (
                                <div style={{ whiteSpace: "nowrap", float: "right", marginTop: 4 }}>
                                    {authState.user && authState.user.is_city_admin === true && (
                                        <Tooltip className={classes.hideSmall} title="Module Configuration">
                                            <IconButton
                                                disabled={readOnly}
                                                className={classes.iconbutton}
                                                component={Link}
                                                to={"/page/" + page.id + "/config"} //route to page config
                                            >
                                                <Icon>settings</Icon>
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                    {section && (
                                        <Tooltip className={classes.hideSmall} title={"Search"}>
                                            <IconButton
                                                className={classes.iconbutton}
                                                component={Link}
                                                to={"/page/" + page.id + "/advancedsearch"}>
                                                <Icon>search</Icon>
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                    {section && section.has_geometry && (
                                        <Tooltip className={classes.hideSmall} title={`${page.name} Map`}>
                                            <IconButton
                                                className={classes.iconbutton}
                                                component={Link}
                                                to={"/map/" + page.id + "/section/" + 0 + "/advancedsearch/" + 1}>
                                                <Icon>map</Icon>
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                    {section && !section.is_master_contact_form && !section.is_time_series_chart && (
                                        <Tooltip className={classes.hideSmall} title={"Table View"}>
                                            <IconButton
                                                className={classes.iconbutton}
                                                component={Link}
                                                to={"/page/" + page.id + "/" + section.id + "/table"} //route to section table view of all records for that page
                                            >
                                                <Icon>view_headline </Icon>
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                    {page && !dashboard && (
                                        <Tooltip className={classes.hideSmall} title={`Dashboard`}>
                                            <IconButton className={classes.iconbutton} component={Link} to={"/dashboard/" + page.id}>
                                                <Icon>timeline</Icon>
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                    {recordsection && perm && !perm.readonlyexternal && (
                                        <Tooltip className={classes.hideSmall} title="Reports" placement="bottom-start" enterDelay={300}>
                                            <IconButton className={classes.iconbutton} onClick={this.handleHelpMenu}>
                                                <Description />
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                    <Tooltip className={classes.hideLarge} title="Module Menu" placement="bottom-start" enterDelay={300}>
                                        <IconButton className={classes.iconbutton} onClick={this.handleSmallMenu}>
                                            <MoreVertIcon />
                                        </IconButton>
                                    </Tooltip>
                                </div>
                            )}



                            < FormUpload
                                page={page}
                                authState={authState}
                                open={open}
                                returnDialog={() => {
                                    this.setState({ open: false });
                                }}
                                section={section.id}
                            />
                            <Menu
                                id="customreports"
                                anchorEl={helpMenu}
                                classes={{
                                    paper: classes.list,
                                }}
                                anchorOrigin={{
                                    vertical: "top",
                                    horizontal: "right",
                                }}
                                transformOrigin={{
                                    vertical: "top",
                                    horizontal: "right",
                                }}
                                open={userHelpOpen}
                                onClose={this.handleHelpMenuClose}>
                                <ListItem button className={classes.topListItem}>
                                    <ListItemText
                                        primary={<Typography variant="h6">Reports</Typography>}
                                        classes={{
                                            root: classes.topListText,
                                            primary: classes.topListText,
                                        }}
                                    />
                                </ListItem>
                                <Typography variant="h7" style={{ padding: '5px', display: 'block' }}   >
                                    <u>Record Form Name: "{recordsection && recordsection.columns.find(c => c.form ? c : null).form}"</u>
                                </Typography>
                                {templates &&
                                    templates.map((t, index) => {
                                        return (
                                            <table key={index} style={{ width: "100%" /*, borderCollapse: "collapse" */ }}>
                                                <tr>
                                                    {!t.name && (
                                                        <td>
                                                            <ListItem
                                                                button
                                                                style={{ borderBottom: "1px solid lightgray" }}
                                                                onClick={() => {
                                                                    // eslint-disable-next-line
                                                                    return window.open(help.url), this.handleHelpMenuClose();
                                                                }}
                                                                className={classes.listItem}>
                                                                <ListItemText primary={t.name} />
                                                            </ListItem>
                                                        </td>
                                                    )}
                                                    {t.name && (
                                                        <td>
                                                            <ListItem
                                                                button
                                                                title="Generate Report as Word Document"
                                                                style={{ borderBottom: "1px solid lightgray", paddingRight: 84 }}
                                                                className={classes.listItem}
                                                                onClick={() => {
                                                                    return (
                                                                        window.open(
                                                                            "/reports/custom/" + authState.user.city_id + "/" + recordsection.id + "/" + t.id
                                                                        ),
                                                                        this.handleHelpMenuClose()
                                                                    );
                                                                }}>
                                                                <ListItemText primary={t.name} />
                                                                <ListItemSecondaryAction>
                                                                    <IconButton
                                                                        edge="end"
                                                                        title="More Options"
                                                                        onClick={(e) => this.handleSmallMenu2(e, t)}>
                                                                        <MoreVertIcon />
                                                                    </IconButton>
                                                                </ListItemSecondaryAction>
                                                            </ListItem>
                                                        </td>
                                                    )}
                                                </tr>
                                            </table>
                                        );
                                    })}


                                {(authState.user.city_id !== 79) && (//dont show for redlake
                                    <table style={{ width: "100%" }}>
                                        <tr>
                                            <td>
                                                <ListItem
                                                    button
                                                    title="Generate Report as Word/PDF/Email Report"
                                                    style={{ borderBottom: "1px solid lightgray", paddingRight: 84 }}
                                                    className={classes.listItem}
                                                >
                                                    <ListItemText
                                                        primary={"Generate Report as Word/PDF/Email Report"}
                                                    />
                                                    <ListItemSecondaryAction>
                                                        <IconButton
                                                            edge="end"
                                                            title="Generate Report as Word/PDF/Email Report"
                                                            onClick={(e) => this.handleSmallMenu3(e)}
                                                        >
                                                            <MoreVertIcon />
                                                        </IconButton>
                                                    </ListItemSecondaryAction>
                                                </ListItem>
                                            </td>
                                        </tr>
                                    </table>
                                )}
                            </Menu>


                            <Menu
                                id="menu-small"
                                anchorEl={smallAnchor}
                                classes={{
                                    paper: classes.list,
                                }}
                                anchorOrigin={{
                                    vertical: "top",
                                    horizontal: "right",
                                }}
                                transformOrigin={{
                                    vertical: "top",
                                    horizontal: "right",
                                }}
                                open={smallMenuOpen}
                                onClose={this.handleSmallMenuClose}>
                                <ListItem button className={classes.topListItem}>
                                    <ListItemText
                                        primary={<Typography variant="h6">Page Menu</Typography>}
                                        classes={{
                                            root: classes.topListText,
                                            primary: classes.topListText,
                                        }}
                                    />
                                </ListItem>
                                {recordsection && (
                                    <ListItem button component={Link} onClick={this.handleHelpMenu} className={classes.listItem}>
                                        <ListItemIcon>
                                            <Icon>description</Icon>
                                        </ListItemIcon>
                                        <ListItemText primary="Reports" />
                                    </ListItem>
                                )}
                                {section && !section.is_master_contact_form && !section.is_time_series_chart && (
                                    <ListItem button component={Link} to={"/page/" + page.id + "/" + section.id + "/table"} className={classes.listItem}>
                                        <ListItemIcon>
                                            <Icon>view_headline</Icon>
                                        </ListItemIcon>
                                        <ListItemText primary={"View all " + section.name + "s"} />
                                    </ListItem>
                                )}
                                {section && section.has_geometry && (
                                    <ListItem
                                        button
                                        component={Link}
                                        to={"/map/" + page.id + "/section/" + 0 + "/advancedsearch/" + 1}
                                        className={classes.listItem}>
                                        <ListItemIcon>
                                            <Icon>map</Icon>
                                        </ListItemIcon>
                                        <ListItemText primary={`${page.name} Map`} />
                                    </ListItem>
                                )}
                                {section && (
                                    <ListItem button component={Link} to={"/page/" + page.id + "/advancedsearch"} className={classes.listItem}>
                                        <ListItemIcon>
                                            <Icon>search</Icon>
                                        </ListItemIcon>
                                        <ListItemText primary={"Search"} />
                                    </ListItem>
                                )}
                                {authState.user && authState.user.is_city_admin === true && (
                                    <ListItem button component={Link} to={"/page/" + page.id + "/config"} className={classes.listItem}>
                                        <ListItemIcon>
                                            <Icon>settings</Icon>
                                        </ListItemIcon>
                                        <ListItemText primary="Module Configuration" />
                                    </ListItem>
                                )}
                                {page && !dashboard && (
                                    <ListItem button component={Link} to={"/dashboard/" + page.id} className={classes.listItem}>
                                        <ListItemIcon>
                                            <Icon>timeline</Icon>
                                        </ListItemIcon>
                                        <ListItemText primary="Dashboard" />
                                    </ListItem>
                                )}
                            </Menu>

                            <Menu
                                id="menu-small2"
                                anchorEl={smallAnchor2}
                                classes={{
                                    paper: classes.list,
                                }}
                                anchorOrigin={{
                                    vertical: "top",
                                    horizontal: "right",
                                }}
                                transformOrigin={{
                                    vertical: "top",
                                    horizontal: "right",
                                }}
                                open={smallMenuOpen2}
                                onClose={this.handleSmallMenuClose2}>
                                <ListItem button className={classes.topListItem}>
                                    <ListItemText
                                        primary={<Typography variant="h6">Options</Typography>}
                                        classes={{
                                            root: classes.topListText,
                                            primary: classes.topListText,
                                        }}
                                    />
                                </ListItem>
                                <ListItem button onClick={() => {
                                    return (
                                        window.open(
                                            "/reports/custom/" + authState.user.city_id + "/" +
                                            recordsection.id + "/" + activeReport.id
                                        ),
                                        this.handleSmallMenuClose2(),
                                        this.handleHelpMenuClose()
                                    );
                                }} className={classes.listItem}>
                                    <ListItemIcon>
                                        <Description />
                                    </ListItemIcon>
                                    <ListItemText primary="Generate Report as Word Document" />
                                </ListItem>
                                <ListItem button onClick={() => {
                                    return (
                                        window.open(
                                            "/reports/custom/" + authState.user.city_id + "/" +
                                            recordsection.id + "/" + activeReport.id + "/pdf"
                                        ),
                                        this.handleSmallMenuClose2(),
                                        this.handleHelpMenuClose()
                                    );
                                }} className={classes.listItem}>
                                    <ListItemIcon>
                                        <PictureAsPdfIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Generate Report as PDF" />
                                </ListItem>
                                <ListItem button onClick={() => {
                                    return (
                                        this.setState({
                                            emailFormOpen: true,
                                            emailReportName: activeReport.name,
                                            emailUrl: recordsection.id + "/" + activeReport.id,
                                        }),
                                        this.handleSmallMenuClose2(),
                                        this.handleHelpMenuClose()
                                    );
                                }} className={classes.listItem}>
                                    <ListItemIcon>
                                        <AttachEmailIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Email Report" />
                                </ListItem>
                            </Menu>

                            <Menu
                                id="menu-small3"
                                anchorEl={smallAnchor3}
                                classes={{
                                    paper: classes.list,
                                }}
                                anchorOrigin={{
                                    vertical: "top",
                                    horizontal: "right",
                                }}
                                transformOrigin={{
                                    vertical: "top",
                                    horizontal: "right",
                                }}
                                open={smallMenuOpen3}
                                onClose={this.handleSmallMenuClose3}>
                                <ListItem button className={classes.topListItem}>
                                    <ListItemText
                                        primary={<Typography variant="h6">Options</Typography>}
                                        classes={{
                                            root: classes.topListText,
                                            primary: classes.topListText,
                                        }}
                                    />
                                </ListItem>


                                <ListItem button onClick={() => {
                                    return (
                                        window.open(
                                            section.parent
                                                ? `/reports/${authState.user.city_id}/${rs[0].parentrecord}/word/parent`
                                                : `/reports/${authState.user.city_id}/${rs[0].parentrecord}/${recordsection.id}/word`
                                        ),
                                        this.handleSmallMenuClose3(),
                                        this.handleHelpMenuClose()
                                    );
                                }} className={classes.listItem}
                                >
                                    <ListItemIcon>
                                        <Description />
                                    </ListItemIcon>
                                    <ListItemText primary="Generate Report as Word Document" />
                                </ListItem>

                                <ListItem button onClick={() => {
                                    return (
                                        window.open(
                                            section.parent
                                                ? `/reports/${authState.user.city_id}/${rs[0].parentrecord}/pdf/parent`
                                                : `/reports/${authState.user.city_id}/${rs[0].parentrecord}/${recordsection.id}/pdf`
                                        ),
                                        this.handleSmallMenuClose3(),
                                        this.handleHelpMenuClose()
                                    );
                                }} className={classes.listItem}
                                >
                                    <ListItemIcon>
                                        <PictureAsPdfIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Generate Report as PDF" />
                                </ListItem>

                                {/* <ListItem button onClick={() => {
                                    return (
                                        this.setState({
                                            emailFormOpen: true,
                                            emailReportName: "Basic Report",
                                            emailUrl: recordsection.id + "/" + rs[0].parentrecord.id,
                                        }),
                                        this.handleSmallMenuClose3(),
                                        this.handleHelpMenuClose()
                                    );
                                }}
                                    className={classes.listItem}
                                >
                                    <ListItemIcon>
                                        <AttachEmailIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Email Report" />
                                </ListItem> */}
                            </Menu>
                        </Grid>

                        {templates && (
                            <EmailForm open={emailFormOpen} url={emailUrl} report_name={emailReportName} returnDialog={this.returnDialog} />
                        )}

                    </Grid>
                )}
            </>
        );
    }
}
TopButtons.displayName = "TopButtons";

TopButtons = connect(
    (state, ownProps) => ({
        rs: getRecordSection(state, ownProps),
        authState: state.auth,
        navState: state.nav,
        permission: getPermission(state, ownProps),

    }),
    null
)(TopButtons);

export default withStyles(styles)(withRouter(TopButtons));